'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.default = init;

var _request = require('@shopify/theme-cart/request');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(_ref) {
  var onTriggerClick = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var updatePayload, elementsThatHaveThisPropertyId;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);

              updatePayload = (0, _defineProperty3.default)({}, els.el.dataset.variantId, parseInt(els.quantity.value, 10));
              elementsThatHaveThisPropertyId = (0, _functional.getElements)('[data-property-id="' + els.el.dataset.propertyId + '"]');


              if (elementsThatHaveThisPropertyId.length > 1) {
                elementsThatHaveThisPropertyId.filter(function (el) {
                  return el !== els.el;
                }).forEach(function (el) {
                  updatePayload[el.dataset.variantId] = parseInt(els.quantity.value, 10);
                });
              }

              _context.next = 6;
              return (0, _request.cartUpdate)({
                updates: updatePayload
              });

            case 6:

              window.location.reload();

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function onTriggerClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  var el = _ref.el,
      context = _ref.context;

  var els = {
    el: el,
    trigger: context.getElement('.' + context.className + '_Trigger'),
    quantity: context.getElement('.js-QuantityAdjuster_Input')
  };

  els.trigger.addEventListener('click', onTriggerClick);

  function setLoading(isLoading) {
    els.trigger.classList.toggle('crt-Products_Update-loading', isLoading);
  }
}